import { Controller, useFormContext } from "react-hook-form";

export const ChoiceField = (props) => {
  const {
    label,
    placeholder,
    dir,
    className,
    registration,
    error,
    options,
    isLoading = false,
    disabled = false,
    leftAddon,
    name,
    onChange = false,
    rules,
  } = props;
  const {
    control,

    formState: { errors },
  } = useFormContext();

  return (
    <FieldWrapper label={label} error={errors[name]}>
      <div className="flex gap-2">
        <CustomSelect
          dir={dir}
          className={`${error && "ring-red-300"}`}
          placeholder={placeholder}
          disabled={isLoading || disabled}
          registration={registration}
          options={options}
          control={control}
          name={name}
          rules={rules}
          onChange={onChange}
          defaultValue={
            onChange
              ? options.find((option) => option.label === "ایران").value
              : ""
          }
        />
      </div>
    </FieldWrapper>
  );
};

export const CustomSelect = ({
  options,
  registration = {},
  isLoading = false,
  control,
  name,
  rules,
  defaultValue,
  onChange = false,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={`${name}`}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <select
          {...field}
          {...props}
          {...registration}
          className={
            "w-full rounded border-0 bg-white px-3 py-3 text-md text-gray-600 placeholder-gray-300 shadow shadow-gray-400 transition-all duration-150 ease-linear focus:outline-none focus:ring"
          }
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {
              onChange(e.target.value);
            }
          }}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
    />
  );
};
export const FieldWrapper = (props) => {
  const { label, className, error, children, hidden, description } = props;
  return (
    <div className={"mb-5 flex-1"}>
      <label className={"block text-md font-medium text-gray-800 text-right"}>
        {label}
        <div className={label && "mt-1"}>{children}</div>
      </label>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className="mt-1 text-sm font-semibold text-red-500 text-right"
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
